import * as notification from '../../components/notifications';

const saveScope = async (select) => {
  const group = select.dataset.notificationGroup;
  const scope = select.value;
  const previous = select.getAttribute('data-current-scope') || scope;

  try {
    const response = await axios.patch('/api/account/notification_settings', { group, scope });

    select.setAttribute('data-current-scope', scope);
    notification.success(response.data.message);
  } catch (e) {
    // Revert to the previously saved value on failure.
    select.value = previous;
    if (window.jQuery && typeof window.jQuery(select).selectpicker === 'function') {
      window.jQuery(select).selectpicker('refresh');
    }

    const message = e.response && e.response.data && e.response.data.message
      ? e.response.data.message
      : e.message;

    notification.danger(message);
  }
};

const initPage = () => {
  const container = document.querySelector('.notification-settings-container');

  if (!container) {
    return;
  }

  // Remember each select's starting value so we can revert if a save fails.
  container.querySelectorAll('select[data-notification-group]').forEach((select) => {
    select.setAttribute('data-current-scope', select.value);
  });

  // bootstrap-select mirrors the choice onto the native <select> and triggers "change",
  // which bubbles up to this delegated handler.
  $(container).on('change', 'select[data-notification-group]', function () {
    saveScope(this);
  });
};

$(initPage);
